// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pulseapp-container .bg-blackcoral {
  background: rgba(93, 96, 104, 0.11) !important;
}
.pulseapp-container .badge-approved {
  background: rgba(16, 185, 103, 0.11) !important;
  color: #10B967 !important;
}
.pulseapp-container .badge-new {
  background: rgba(55, 149, 201, 0.11) !important;
  color: #3795C9 !important;
}
.pulseapp-container .badge-rejected {
  background: rgba(217, 9, 9, 0.11) !important;
  color: #D90909 !important;
}
.pulseapp-container .approve-btn {
  background-color: #F1FFDD;
  border: 1px solid #AFE365;
  border-radius: 50%;
  color: #55B938;
  font-size: 1rem;
  padding: 0 0.25rem;
}
.pulseapp-container .reject-btn {
  background-color: #FFDDDD;
  border: 1px solid #F15757;
  border-radius: 50%;
  color: #D90909;
  font-size: 1rem;
  padding: 0 0.25rem;
}
.pulseapp-container .cv-btn {
  background-color: transparent;
  border: none;
  padding: 0;
}
.pulseapp-container .cv-btn:hover {
  background-color: transparent !important;
  border: none !important;
}

.file-offcanvas {
  width: 75% !important;
}

.action-modal .cancel-btn {
  background-color: #FFF;
  border: 1px solid #c5d2c8;
  border-radius: 0.5rem;
  color: #000;
}
.action-modal .cancel-btn:hover {
  background-color: #CEE0F5;
  border: 1px solid #CEE0F5;
  color: #0851A3;
}
.action-modal .confirm-btn {
  background-color: #FFF;
  border: 1px solid #c5d2c8;
  border-radius: 0.5rem;
  color: #FFF;
}`, "",{"version":3,"sources":["webpack://./../jobportal/src/components/PulseApplicationContent/PulseApplicationContent.scss"],"names":[],"mappings":"AACE;EACE,8CAAA;AAAJ;AAGE;EACE,+CAAA;EACA,yBAAA;AADJ;AAIE;EACE,+CAAA;EACA,yBAAA;AAFJ;AAKE;EACE,4CAAA;EACA,yBAAA;AAHJ;AAME;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAJJ;AAOE;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AALJ;AAQE;EACE,6BAAA;EACA,YAAA;EACA,UAAA;AANJ;AASE;EACE,wCAAA;EACA,uBAAA;AAPJ;;AAWA;EACI,qBAAA;AARJ;;AAYE;EACE,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;AATJ;AAYE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAVJ;AAaE;EACE,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;AAXJ","sourcesContent":[".pulseapp-container {\n  .bg-blackcoral {\n    background: rgba(93,96,104,0.11) !important;\n  }\n  \n  .badge-approved {\n    background: rgba(16, 185, 103, 0.11) !important;\n    color: #10B967 !important;\n  }\n\n  .badge-new {\n    background: rgba(55, 149, 201, 0.11) !important;\n    color: #3795C9 !important;\n  }\n\n  .badge-rejected {\n    background: rgba(217, 9, 9, 0.11) !important;\n    color: #D90909 !important;\n  }\n\n  .approve-btn {\n    background-color: #F1FFDD;\n    border: 1px solid #AFE365;\n    border-radius: 50%;\n    color: #55B938;\n    font-size: 1rem;\n    padding: 0 0.25rem;\n  }\n\n  .reject-btn {\n    background-color: #FFDDDD;\n    border: 1px solid #F15757;\n    border-radius: 50%;\n    color: #D90909;\n    font-size: 1rem;\n    padding: 0 0.25rem;\n  }\n\n  .cv-btn {\n    background-color: transparent;\n    border: none;\n    padding: 0;\n  }\n\n  .cv-btn:hover {\n    background-color: transparent !important;\n    border: none !important;\n  }\n}\n\n.file-offcanvas {\n    width: 75% !important;\n}\n\n.action-modal {\n  .cancel-btn {\n    background-color: #FFF;\n    border: 1px solid #c5d2c8;\n    border-radius: 0.5rem;\n    color: #000;\n  }\n\n  .cancel-btn:hover {\n    background-color: #CEE0F5;\n    border: 1px solid #CEE0F5;\n    color: #0851A3;\n  }\n\n  .confirm-btn {\n    background-color: #FFF;\n    border: 1px solid #c5d2c8;\n    border-radius: 0.5rem;\n    color: #FFF;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
